// extracted by mini-css-extract-plugin
export var root = "style-module--root--+wsJ+";